module.exports = __webpack_public_path__ + "img/WechatIMG669.793a9b0e.png";